<template>
  <main class="landing">
    <header v-if="showVideoSplash" :class="scrollAway && '-offset'" class="scroll-cursor landing-header">
      <div class="header-wrapper">
        <div class="intrinsic-wrapper">
          <video
            autoplay="autoplay"
            playsinline
            muted
            loop
            @onload="initTilt"
            poster="https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/tank_xmas_video_poster.jpg?alt=media"
          >
            <source
              src="https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/tank_xmas_video_small.webm?alt=media"
            />
            <source
              src="https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/tank_xmas_video.mp4?alt=media"
            />
          </video>

          <svg ref="mask" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285 80" preserveAspectRatio="xMidYMid slice">
            <defs>
              <mask id="mask" x="0" y="0" width="100%" height="100%">
                <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
                <text font-size="36px" x="49%" y="55%">Tank</text>
              </mask>
            </defs>
            <g mask="url(#mask)">
              <rect x="0" y="0" width="100%" height="100%" fill="#949588" />
            </g>
          </svg>
        </div>

        <button><a href="#intro">Skrolli alla</a></button>
      </div>
    </header>

    <!-- <div class="logo">Tank</div> -->

    <section class="intro-wrapper scroll-cursor" id="intro" ref="intro" v-show="showIntro">
      <p class="intro">
        Jõulud ja aastalõpp on klišee kohaselt rahu ja rõõmu aeg. On nad jeee. Kaamos. Kiirustamine. Piinlikkus.
        Masendus.
      </p>

      <p class="intro">
        Kõige selle vastu aitab meie ülikasulik tööriist. Meisterda oma kätega personali&shy;seeritud
        digi&shy;jõulukaart, mis teeb nii Sinu kui saaja tuju heaks! Või noh… midagi ta selle tujuga igal juhul teeb!
      </p>
    </section>

    <select-template ref="gallery" @input="getImage" />
  </main>
</template>

<script>
import Tilt from 'vanilla-tilt'
import SelectTemplate from '@/components/SelectTemplate'

export default {
  name: 'landing',
  data() {
    return {
      image: null,
      scrollAway: false,
      showVideoSplash: !this.galleryHash,
      showIntro: !this.galleryHash,
      fixedGallery: !this.galleryHash
    }
  },
  props: {
    galleryHash: Boolean
  },
  components: { SelectTemplate },
  created() {
    if (!this.galleryHash) {
      // TODO: If scrolled, scroll to top first?
      // if (window.scrollY > 0) window.scrollTo(0, 0)
      // window.addEventListener('scroll', this.scrollSplash, { once: true, passive: true })
    }
  },
  async mounted() {
    await this.$nextTick()

    if (this.galleryHash) return this.scrollToGallery()

    // this.scrollIntroListener()

    const isSafari = window.safari || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    console.info('Safari check', isSafari)
    if (isSafari) return console.info('Safari does not allow Tilt')

    if (window.innerWidth < 720 && typeof (window.DeviceOrientationEvent || {}).requestPermission === 'function') {
      window.DeviceOrientationEvent.requestPermission().then(permissionState => {
        this.initTilt(permissionState === 'granted')
      })
    } else this.initTilt(false)

    // TODO: Throttle listener
    // window.addEventListener('scroll', this.handleTilt)
  },
  beforeDestroy() {
    this.destroyTilt()
    window.removeEventListener('scroll', this.scrollSplash)
  },
  methods: {
    handleTilt() {
      // if (window.scrollTop > 100vh && this.tilting) this.destroyInit()
      // else if (window.scrollTop < 100vh && !this.tilting) this.initTilt()
    },
    initTilt(gyro) {
      this.destroyTilt()

      // TODO: Fix SVG mask for Safari
      const isSafari = window.safari || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      console.info('Safari check', isSafari)
      if (isSafari) return console.info('Safari does not allow Tilt')

      Tilt.init(this.$refs.mask, {
        max: 10,
        perspective: 1300,
        reset: false,
        gyroscope: gyro,
        'full-page-listening': !gyro
      })
    },
    destroyTilt() {
      this.$refs.mask && 'vanillaTilt' in this.$refs.mask && this.$refs.mask.vanillaTilt.destroy()
    },
    getImage(value) {
      const imagePrefix = value.image.split('/')[2][0]
      value.orientation = imagePrefix

      this.$emit('submit', {
        name: 'template',
        value
      })
      this.$router.push('/upload')
    },
    scrollGalleryListener() {
      const onScrollToBottom = this.$refs.galleryTrigger
      const onIntersection = ([{ isIntersecting }]) => isIntersecting && (this.fixedGallery = false)
      const io = new IntersectionObserver(onIntersection, { threshold: 1 })

      io.observe(onScrollToBottom)
    },
    scrollIntroListener() {
      const onScrollToBottom = this.$refs.scrollTrigger
      const onIntersection = ([{ isIntersecting }]) => isIntersecting && this.removeIntroText()

      const io = new IntersectionObserver(onIntersection, { threshold: 1 })

      io.observe(onScrollToBottom)
    },
    async removeIntroText() {
      this.showIntro = false
      await this.$nextTick()
      this.fixedGallery = false
      await this.$nextTick()
      this.scrollToGallery(false)
    },
    scrollToGallery(smooth = true) {
      this.$refs.gallery.$el.scrollIntoView({
        block: 'start',
        behavior: smooth ? 'smooth' : 'instant'
      })
    },
    scrollSplash() {
      // this.scrollAway = true
      // setTimeout(() => {
      //   this.destroyTilt()
      //   this.showVideoSplash = false
      // }, 1000)
    }
  }
}
</script>

<style lang="scss">
.landing {
  font-size: 1rem;

  &-header {
    // position: relative;
    height: 100vh;
  }

  .header-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--background);
    z-index: 10;
    width: 100%;
    height: 100vh;
    transition: transform 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);

    button {
      position: absolute;
      bottom: 8vh;
      left: 0;
      right: 0;
      width: 100%;
      display: block;
      margin-bottom: 2rem;
    }

    &.-offset {
      transform: translateY(-110%);
    }
  }
  .intrinsic-wrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 50%;
    width: 100%;
    padding-bottom: 80%;
    transform: translateY(-50%);
    overflow: hidden;

    @media screen and (max-height: 80rem) {
      padding-bottom: 70%;
    }
    @media screen and (min-width: 80rem) {
      padding-bottom: 60%;
    }
  }
  h1 {
    color: black;
    position: absolute;
  }
  video {
    position: absolute;
    height: 100%;
    width: 80%;
  }
  svg {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 20px; // needed for FF, Safari, Edge
  }
  svg text {
    text-anchor: middle;
    font-weight: bold;
  }

  .intro-wrapper {
    // height: 80vh;
    // min-height: 50rem;
    font-weight: 900;
    padding: 0 2em;
    position: relative;
    z-index: 10;

    @media screen and (min-width: 100rem) {
      margin-top: 5rem;
    }
  }
  .intro-scroll-wrapper {
    position: absolute;
    z-index: 5;
    height: 700vh;
    // overflow-y: auto;

    &::before {
      content: '';
      position: fixed;
      z-index: -1;
      top: 0;
      left: -25vw;
      height: 100vh;
      width: 150vw;
      background-color: rgb(148, 149, 136, 0.88);
    }
  }
  .intro-scroll-trigger {
    display: block;
    margin-top: 30vh;
  }
  .intro {
    font-size: 5em;
    & + .intro {
      padding-top: 2em;
    }
    @media screen and (max-width: 40rem) {
      font-size: 7em;
    }
  }
  .gallery-intro {
    text-align: center;
    max-width: 50rem;
    margin: 3rem auto;
    font-size: 2em;
    font-weight: 600;

    @media screen and (max-width: 40rem) {
      font-size: 3.4em;
    }
  }

  .select-template {
    &.-fixed-gallery {
      position: fixed;
      top: 0;
      width: 80%;
      left: 0;
      right: 0;
      margin: 2rem auto;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 55rem) {
    font-size: 0.75rem;
  }
  @media screen and (max-width: 40rem) {
    font-size: 0.35rem;

    svg {
      left: 6px;
    }
  }
  @media screen and (min-width: 80rem) {
    svg text {
      font-size: 26px;
    }
  }
  @media screen and (min-width: 120rem) {
    video {
      width: 70%;
    }
  }
}
</style>
